import { Input, InputProps } from "@babackapp/ui/components/input";
import { forwardRef, useCallback } from "react";
import FormInputContainer from "./form-input-container";

type FormInputProps = Omit<InputProps, "disabled"> & {
  label: string;
  description?: string;
  disabled?: boolean | string;
  selectAllOnFocus?: boolean;
};

const FormInput = forwardRef(function FormInput(
  {
    label,
    description,
    disabled,
    selectAllOnFocus,
    onFocus,
    ...props
  }: FormInputProps,
  ref: React.Ref<HTMLInputElement>,
) {
  const _onFocus = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      if (selectAllOnFocus) {
        e.target.select();
      }
      onFocus?.(e);
    },
    [selectAllOnFocus, onFocus],
  );

  return (
    <FormInputContainer
      disabled={disabled}
      label={label}
      description={description}
    >
      <Input ref={ref} {...props} disabled={!!disabled} onFocus={_onFocus} />
    </FormInputContainer>
  );
});

FormInput.displayName = "FormInput";

export default FormInput;
